const INTEGRATED_LEAGUES = [
    'NCAA Football',
    'NCAA Basketball',
    'College Baseball',
    'NBA Basketball',
    'NHL Hockey',
    'NFL Football',
    'Soccer',
    'MLB Baseball'
]
const LEAGUES = [
    {
        genre_name: 'basketball',
        sub_genre_name: 'nba'
    },
    {
        genre_name: 'hockey',
        sub_genre_name: 'nhl'
    },
    {
        genre_name: 'football',
        sub_genre_name: 'nfl'
    },
    {
        genre_name: 'soccer',
        sub_genre_name: 'mls'
    },
    {
        genre_name: 'baseball',
        sub_genre_name: 'mlb'
    },
    {
        sub_genre_name: 'college',
        genre_name: 'football'
    },
    {
        sub_genre_name: 'college',
        genre_name: 'basketball'
    },
    {
        sub_genre_name: 'college',
        genre_name: 'baseball'
    }
]

const isPerformerInLeagueSports = (performer, isIntegrated) => {
    if (isIntegrated) {
        if (!performer.genre_name) { return false }
        return INTEGRATED_LEAGUES.includes(performer.genre_name)
    } else {
        if (!performer.genre_name || !performer.sub_genre_name) { return false }
        return LEAGUES.some(league => performer.genre_name === league.genre_name && performer.sub_genre_name === league.sub_genre_name)
    }
}

export {
    isPerformerInLeagueSports
}
